"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useDidUpdate;

var _react = require("react");

// mimc didUpdate, i.e: same as useEffect, but not get called on mount
function useDidUpdate(callback, deps) {
  var didMountRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (didMountRef.current) {
      callback();
    } else {
      didMountRef.current = true;
    }
  }, deps);
}